import baseRoute from '../baseRoute';

export type * from './viewModel';
export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/edit/job/${number | ':jobId'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/edit/job/:jobId`;

export const URL = (jobId: number): RouteDefinition => `${baseRoute}/edit/job/${jobId}`;
